let HOST = '';
let LIVE_HOST = 'https://apilive.knowbox.cn';

if (location.href.indexOf('beta-www') > -1) {
    LIVE_HOST = 'https://qa3-apilive.knowbox.cn';
} else if (location.href.indexOf('pre-www') > -1) {
    LIVE_HOST = 'https://beta-apilive.knowbox.cn';
}

const api = {
    COMMON_INFO: `${HOST}/common/info`,
    NEWS_LIST: `${HOST}/news/list`,
    NEWS_DETAIL: `${HOST}/news/detail`,
    TEACHER_LIST: `${LIVE_HOST}/teacher/disclosure.do`
};

export default api;